module.exports = __webpack_public_path__ + "img/LOGO.db0325df.svg";